/**
 * R5Faq
 * -----------------------------------------------------------
 * Categorized FAQ list with native <details>/<summary> for
 * built-in accordion behavior + a11y for free.
 *
 * Props:
 *   categories: [{ label, items: [{ q, a }] }]
 *   className:  extra classes
 */
import React from 'react';

export function R5Faq({ categories = [], className = '', ...rest }) {
  const cls = ['r5-faq', className].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      {categories.map((cat, ci) => (
        <React.Fragment key={ci}>
          {cat.label && <div className="r5-faq__cat">{cat.label}</div>}
          {(cat.items || []).map((item, ii) => (
            <details key={ii} className="r5-faq__item">
              <summary>
                <div className="r5-faq__q">{item.q}</div>
              </summary>
              <div className="r5-faq__a">{item.a}</div>
            </details>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}

export default R5Faq;
